export default __webpack_public_path__ + "static/media/sv11_kr_alph_a2.9266150f.mp3";